import { render } from "./TheHeadersider.vue?vue&type=template&id=64d36f91&scoped=true"
import script from "./TheHeadersider.vue?vue&type=script&lang=js"
export * from "./TheHeadersider.vue?vue&type=script&lang=js"

import "./TheHeadersider.vue?vue&type=style&index=0&id=64d36f91&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d36f91"]])

export default __exports__